import api from '../../services/api';
import * as type from '../types';

export default {
    namespaced: true,
    state: {
        brands: [],
        headers: [
            {
              text: 'Segment',
              value: 'segment',
              sortable: true,
              width: '120'
            },
            {
              text: 'Brand',
              value: 'brandName',
              sortable: true,
              width: '200'
            },
            {
              text: 'Status',
              value: 'status',
              sortable: true,
              width: '120'
            },
            {
              text: 'Fulfillment',
              value: 'fulfillment',
              sortable: true,
              width: '120'
            },
            {
              text: 'DS Fee',
              value: 'dsFee',
              sortable: true,
              width: '100'
            },
            {
              text: 'DS Fee Notes',
              value: 'dsFeeNotes',
              sortable: true,
              width: '200'
            },
            {
              text: 'Discount',
              value: 'discount',
              sortable: true,
              width: '120'
            },
            {
              text: 'Terms',
              value: 'terms',
              sortable: true,
              width: '100'
            },
            {
              text: 'Additional Charges',
              value: 'otherAdditionalCharges',
              sortable: true,
              width: '200'
            },
            {
              text: 'Actions',
              width: '120',
              fixed: "right"
            }
        ],
        exportHeaders: []
    },
    getters: {
        getBrands: state => state.brands,
        getHeaders: state => state.headers,
        getExportHeaders: state => state.headers.filter(e => e.value === 'action'),
        getSearch: state => state.search
    },
    mutations: {
        [type.GET_BRANDS]: (state, payload) =>  state.brands = payload,
        [type.ADD_BRAND]: (state, payload) => state.brands.unshift(payload),
        [type.UPDATE_BRAND]: (state, payload) => {
            for(let x in state.brands){
                let data = state.brands[x];
                if( data.id === payload.id){
                    data = payload;
                }
            }
        },
        [type.DELETE_BRAND]: (state, payload) => state.brands = state.brands.filter(e => e.id !== payload)
    },
    actions: {
        [type.GET_BRANDS]: async ({commit}) => {
            commit(`global/${type.SET_LOADING}`, null, { root: true });
            commit(type.GET_BRANDS, []);
            try {
                let response = await api.get('/brand');
                if(response.status === 200){
                    commit(type.GET_BRANDS, response.data);
                }
            } catch (error) {
                commit(type.GET_BRANDS, []);
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }finally{
                commit(`global/${type.REMOVE_LOADING}`, null, { root: true });
            }
        },

        [type.ADD_BRAND]: async ({ commit }, payload) => {
            commit(`global/${type.SET_LOADING}`, null, { root: true });
            try {
                let response = await api.post('/brand', JSON.stringify(payload));
                if(response.status === 200){
                    let res = response.data.brand[0];
                    let data = {
                        brandName: res.brand_name,
                        status: res.relationship_status,
                        segment: res.segment,
                        fulfillment: res.fulfillment,
                        dsFee: res.ds_fee,
                        dsFeeNotes: res.ds_fee_notes,
                        discount: res.discount,
                        discountNotes: res.discount_notes,
                        terms: res.terms,
                        otherAdditionalCharges: res.other_additional_charges
                    }
                    commit(type.ADD_BRAND, data);
                    commit(`global/${type.CLOSE_DIALOG}`, null, { root: true });
                    commit(`global/${type.SET_MESSAGE}`, { type: 'success', message: response.data.msg }, { root: true });
                }
            } catch (error) {
                commit(`global/${type.CLOSE_DIALOG}`, null, { root: true });
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error.response.data.msg }, { root: true });
            }finally{
                commit(`global/${type.REMOVE_LOADING}`, null, { root: true });
            }
        },

        [type.UPDATE_BRAND]: async ({commit}, payload) => {
          commit(`global/${type.SET_LOADING}`, null, { root: true });
            try {
                let response = await api.post(`/brand/${payload.id}`, payload);
                if(response.status === 200){
                    commit(type.UPDATE_BRAND, payload);
                    commit(`global/${type.CLOSE_DIALOG}`, null, { root: true });
                    commit(`global/${type.SET_MESSAGE}`, { type: 'success', message: response.data.msg }, { root: true });
                }
            } catch (error) {
                commit(`global/${type.CLOSE_DIALOG}`, null, { root: true });
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error.response.data.msg }, { root: true });
            }finally{
                commit(`global/${type.REMOVE_LOADING}`, null, { root: true });
            }
        },

        [type.DELETE_BRAND]: async ({commit}, payload) => {
            commit(`global/${type.SET_LOADING}`, null, { root: true });
            try {
                let response = await api.delete(`/brand/${payload}`);
                if(response.status === 200){
                    commit(type.DELETE_BRAND, payload);
                    commit(`global/${type.CLOSE_DIALOG}`, null, { root: true });
                    commit(`global/${type.SET_MESSAGE}`, { type: 'success', message: response.data.msg }, { root: true });
                }
            } catch (error) {
                commit(`global/${type.CLOSE_DIALOG}`, null, { root: true });
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error.response.data.msg }, { root: true });
            }finally{
                commit(`global/${type.REMOVE_LOADING}`, null, { root: true });
            }
        }
    }
}